import { FlowerOutlineIcon } from './FlowerOutlineIcon';

/**
 * author: Google
 * id 0BF283D1-7C12-4E5F-B136-558BE534AC8D
 * name flower-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flower-outline.svg
 * tags
 * - Nature 
 * - Agriculture 
 */
export const LocalFloristOutlineIcon = FlowerOutlineIcon;
export default LocalFloristOutlineIcon